module.exports = __webpack_public_path__ + "06_long_black.ee70bc7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/06_long_black.png
// module id = uWQx
// module chunks = 0